"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gnitekram = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@smash-sdk/core");
const core_2 = require("@smash-sdk/core");
const errors_1 = require("./errors");
tslib_1.__exportStar(require("./errors"), exports);
tslib_1.__exportStar(require("./types/GetUsage/GetUsage"), exports);
const endpoints = {
    global: "https://gnitekram.fromsmash.co",
};
core_2.config.setHosts("gnitekram", endpoints, false);
class Gnitekram extends core_1.Client {
    constructor(params = {}) {
        super({ service: "gnitekram", ...params, type: "global", userAgent: "@smash-sdk/gnitekram@0.0.1-alpha.2" });
        this.errors = errors_1.errors;
    }
    getUsage(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/key/:key/id/:id/usage",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        key: params["key"],
                        id: params["id"],
                    },
                    queryParameters: {
                        version: "01-2025",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUsageError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        });
    }
}
exports.Gnitekram = Gnitekram;
Gnitekram.errors = errors_1.errors;
